import { env } from './env';

export const environment = {
  production: false,
  loginUrl: 'https://www1-staging.isracard-global.com/system/login/auth ',
  languages: ['he', 'en'],
  defaultLanguage: 'he',
  amplitudeId: env.amplitudeId,
  hotJarId: env.hotJarId,
  tawkToProjectId: env?.tawkToProjectId,
  tawkToChatId: env?.tawkToChatId,
  apiDomain: env?.apiDomain,
  sendSmallIncomeHookUrl: env.sendSmallIncomeHookUrl,
};
